import { useNavigate } from "react-router-dom";
// import { useDispatch, useSelector } from "react-redux";

const useLspDashboard = (id) => {
  const navigate = useNavigate();
  const handleCustomerView = () => {
    navigate(`/lsp/${id}/customer-portfolio`);
  };
  return {
    statevalues: {},
    handleCustomerView,
  };
};

export default useLspDashboard;
